import { useContext, useEffect, useMemo, useRef } from "react";

// Contexts
import { CartContext } from "@cart-client/contexts/CartContext";

// Utils
import { getCloudinaryRawUrl, isEmpty } from "@swiggy-private/js-utils";

// Constants
import { LOTTIE_ASSETS } from "@swiggy-private/core-ui";

// helpers
import { isPopFlow } from "@swiggy-private/checkout-core";
import { getFreebieWidgetData } from "@cart-client/helpers/FreebieWidget";

export const usePrefetchSnaccFreebieLottie = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;
    const freebieWidgetLottieFetchRef = useRef<boolean>(false);
    const isPopCart = isPopFlow();

    // check in render details if snacc freebie widget is present
    const freebieWidgetData = useMemo(() => {
        return getFreebieWidgetData(cartResponse);
    }, [cartResponse]);

    useEffect(() => {
        if (isPopCart && !isEmpty(freebieWidgetData) && !freebieWidgetLottieFetchRef.current) {
            fetch(getCloudinaryRawUrl(LOTTIE_ASSETS.FREEBIE_WIDGET_LOTTIE_FILE_ID) || "")
                .then(() => {
                    freebieWidgetLottieFetchRef.current = true;
                })
                .catch();
        }
    }, [freebieWidgetData, isPopCart]);
};
